// src/config/config.js — Centralised frontend configuration constants
export const isDev = process.env.NODE_ENV === 'development';

export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';

export const ANALYTICS_CONFIG = Object.freeze({
  websiteId: process.env.REACT_APP_UMAMI_WEBSITE_ID || '',
  scriptSrc: process.env.REACT_APP_UMAMI_SCRIPT_SRC || '/stats/np.js',
  domains: process.env.REACT_APP_UMAMI_DOMAINS || 'www.neoprof.fr,neoprof.fr',
});
